<template>
  <div
    v-if="env !== 'production'"
    class="bar"
    :class="{
      'bar-qa': env.includes('qa'),
      'bar-development': env === 'development',
      'bar-staging': env === 'staging',
    }"
  >
    <span class="bar-text">{{ envText }}</span>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import { envBarText } from "@/lib/env-helper";

export default Vue.extend({
  name: "env-bar-component",
  computed: {
    env(): string {
      return process.env.VUE_APP_MODE || "development";
    },
    envText(): string {
      return envBarText(process.env.VUE_APP_MODE);
    },
  },
});
</script>

<style lang="scss" scoped>
@import "~@vacancorp/vacan-scss/variables/color-palette.scss";
.bar {
  color: white;
  padding: 8px 0;
  line-height: 21px;
  font-size: 14px;
  font-weight: 700;
  text-align: center;
  white-space: nowrap;

  &.bar-qa {
    background-color: var(--link);
  }
  &.bar-development {
    background-color: var(--tiger);
  }
  &.bar-staging {
    background-color: var(--important);
  }
}
</style>
